// constants for the Vip Ad slots

import { AD_NETWORK_CODE, AD_PATH_BASE } from '@/features/advertisement/constants/adSlots'
import { type PrebidConfig } from '@/features/advertisement/constants/prebid'
import { type AdSizesMap } from '@/features/advertisement/types/adConfig'

export const VIP_GPT_ID = {
  GPT_SPONSORED_LEFT: 'gpt-sponsored-left',
  GPT_SPONSORED_RIGHT: 'gpt-sponsored-right',
  IMAGE_GALLERY_OVERLAY: 'ImageLeaderBoard',
  LEADER: 'gpt-vip-leader',
  FOOTER: 'gpt-vip-footer',
  R2S: 'gpt-r2s-vip',
}

export const adSizesMapVip: AdSizesMap = {
  [VIP_GPT_ID.GPT_SPONSORED_LEFT]: [
    [575, 210],
    [350, 90],
  ],
  [VIP_GPT_ID.GPT_SPONSORED_RIGHT]: [
    [575, 210],
    [350, 90],
  ],
  [VIP_GPT_ID.IMAGE_GALLERY_OVERLAY]: [
    [320, 50],
    [728, 90],
  ],
  [VIP_GPT_ID.LEADER]: [
    [728, 90],
    [970, 90],
  ],
  [VIP_GPT_ID.FOOTER]: [
    [300, 250],
    [320, 50],
    [728, 90],
    [970, 90],
  ],
  [VIP_GPT_ID.R2S]: [
    [300, 250],
    [320, 50],
    [728, 90],
    [970, 250],
  ],
}

/**
 * ad unit path the for vip
 * this is how GAM determines what ad inventory to serve
 */
export const BASE_AD_PATH_FOR_VIP = `/${AD_NETWORK_CODE}/${AD_PATH_BASE}vip`

/**
 * page test group array to be passed as a GPT targeting value in the ad config
 * based on what we're sending on legacy
 */
export const PTG = [
  'CASINT4862_0',
  'CASINT5487_1',
  'KCA34949_0',
  'KCA38991_0',
  'KCAN1050__1',
  'KCAN10715__1',
  'KCAN13748__-99',
  'KCAN15957__0',
  'KCAN17895__1',
  'KCAN1806__1',
  'KCAN18206__1',
  'KCAN18697__1',
  'KCAN19025__-99',
  'KCAN20660__1',
  'KCAN20710__0',
  'KCAN21013__1',
  'KCAN24506__0',
  'KCAN25089__0',
  'KCAN25434__2',
  'KCAN4308__-99',
  'KCAN5349__-99',
  'KCAN6062__0',
  'KCAN6084__-99',
  'KCAN667_1',
  'KCAN810__1',
  'KCAN909__0',
  'gpt-vip-footer_R',
]

export const VIP_PREBID_SLOTS: Record<string, PrebidConfig> = {}
